<template>
  <div id="contenedor-eliminar-plantilla">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Plantilla </v-card-title>
      <v-card-text>
        <span
        class="secondary--text"> ¿Desea eliminar la plantilla? </span>
        <v-divider></v-divider>
        <v-row>
        <span class="font-weight-bold">
            {{plantillaEliminar.nombre}}
            ({{ new Date(`${plantillaEliminar.createdAt}`).toLocaleDateString() }})
        </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarPlantilla"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixConfiguracionPlantillas from './mixConfiguracionPlantillas';

export default {
  name: 'EliminarPlantilla',
  mixins: [mixConfiguracionPlantillas],
  props: {
    plantillaEliminar: {
      type: Object,
    },
    modulo: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    mixEliminarPlantilla() {
      const plantillaEliminar = { id: this.plantillaEliminar.id };
      this.eliminarPlantilla(plantillaEliminar);
    },
  },
};
</script>

<style>
</style>
